import { LintIssue } from './copyLint';

import { CopyDetail } from '@/services/lifecycleAPI';

const unique = (messages: string[]) => Array.from(new Set(messages));

const plural = (n: number) =>
  n > 1 ? `${n} problems block` : `${n} problem blocks`;

export const summarizeProblems = (
  detail: CopyDetail,
  names: string[],
  issues: LintIssue[],
  saveError: string | null,
): { problemTitle: string | null; listed: string[] } => {
  const draft = detail.draft;
  const serverLint = draft
    ? names.flatMap((name) =>
        (draft.lint_errors?.[name] ?? []).map((m) =>
          names.length > 1 ? `${name}: ${m}` : m,
        ),
      )
    : [];
  const serverStructure = draft?.structure_errors ?? [];
  const blocking = unique([
    ...serverStructure,
    ...issues.filter((i) => i.blocksSave).map((i) => i.message),
  ]);
  const soft = unique([
    ...serverLint,
    ...issues.filter((i) => !i.blocksSave).map((i) => i.message),
  ]);
  let problemTitle: string | null = null;
  if (blocking.length > 0) {
    problemTitle = `${plural(blocking.length)} Save draft and Publish`;
  } else if (soft.length > 0) {
    problemTitle = `${plural(soft.length)} Publish (a draft can still be saved)`;
  }
  const listed = unique([
    ...serverStructure,
    ...serverLint,
    ...(saveError ? [saveError] : []),
  ]);
  return { problemTitle, listed };
};
